/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Widerrufsrecht_RequiredInputs */

const en_widerrufsrecht_required = /** @type {(inputs: Widerrufsrecht_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm the waiver of withdrawal rights to continue.`)
};

const de_widerrufsrecht_required = /** @type {(inputs: Widerrufsrecht_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte bestaetigen Sie den Widerrufsrechtsverzicht, um fortzufahren.`)
};

const fr_widerrufsrecht_required = /** @type {(inputs: Widerrufsrecht_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez confirmer la renonciation au droit de retractation pour continuer.`)
};

const es_widerrufsrecht_required = /** @type {(inputs: Widerrufsrecht_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirme la renuncia al derecho de desistimiento para continuar.`)
};

const it_widerrufsrecht_required = /** @type {(inputs: Widerrufsrecht_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma la rinuncia al diritto di recesso per continuare.`)
};

const nl_widerrufsrecht_required = /** @type {(inputs: Widerrufsrecht_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevestig de afstand van het herroepingsrecht om door te gaan.`)
};

const pl_widerrufsrecht_required = /** @type {(inputs: Widerrufsrecht_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prosze potwierdzic zrzeczenie sie prawa do odstapienia, aby kontynuowac.`)
};

const fi_widerrufsrecht_required = /** @type {(inputs: Widerrufsrecht_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvista peruutusoikeudesta luopuminen jatkaaksesi.`)
};

const da_widerrufsrecht_required = /** @type {(inputs: Widerrufsrecht_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekraeft venligst afkald pa fortrydelsesretten for at fortsaette.`)
};

const sv_widerrufsrecht_required = /** @type {(inputs: Widerrufsrecht_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekrafta avsagelsen av angerratten for att fortsatta.`)
};

/**
* | output |
* | --- |
* | "Please confirm the waiver of withdrawal rights to continue." |
*
* @param {Widerrufsrecht_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const widerrufsrecht_required = /** @type {((inputs?: Widerrufsrecht_RequiredInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widerrufsrecht_RequiredInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_widerrufsrecht_required(inputs)
	if (locale === "fr") return fr_widerrufsrecht_required(inputs)
	if (locale === "es") return es_widerrufsrecht_required(inputs)
	if (locale === "it") return it_widerrufsrecht_required(inputs)
	if (locale === "nl") return nl_widerrufsrecht_required(inputs)
	if (locale === "pl") return pl_widerrufsrecht_required(inputs)
	if (locale === "fi") return fi_widerrufsrecht_required(inputs)
	if (locale === "da") return da_widerrufsrecht_required(inputs)
	if (locale === "sv") return sv_widerrufsrecht_required(inputs)
	return en_widerrufsrecht_required(inputs)
});